"use client";
import { useEffect } from "react";
import { ServerErrorPage } from "./ServerErrorPage";
import { Metadata } from "next";
import { DreamServerThemeProvider } from "@portal/app/_components/context/DreamServerThemeProvider";
import { DreamClientThemeProvider } from "@portal/app/_components/context/DreamClientThemeProvider";
import { DreamErrorBoundary } from "@portal/app/_components/DreamErrorBoundary";
import { AnalyticsProvider } from "@portal/app/_components/context/AnalyticsProvider";
import { publicSans } from "./fonts";
import { generateSEOMetadata } from "@portal/app/_components/generateSEOMetadata";
import { PageProvider } from "./_components/context/PageContext";
import * as Sentry from "@sentry/nextjs";

export const metadata: Metadata = generateSEOMetadata({
  title: "Something went wrong",
});

/**
 * https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-errors-in-root-layouts
 * @param error
 * @param _reset
 * @constructor
 */
export default function GlobalError({
  error,
  reset: _reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <html lang="en" className={`${publicSans.className} ${publicSans.variable}`}>
      <body>
        <DreamServerThemeProvider>
          <DreamClientThemeProvider>
            <DreamErrorBoundary>
              <PageProvider
                tokenInfo={undefined}
                deviceInfo={null}
                experiments={undefined}
                cfGeolocation={{
                  cfCountry: undefined,
                  cfCity: undefined,
                  cfState: undefined,
                  cfZip: undefined,
                }}
              >
                {/* The fallback replaces the root consent initialization. Keep
                    the footer's context without starting Google tags or a CMP. */}
                <AnalyticsProvider trackingScriptsEnabled={false}>
                  <ServerErrorPage error={error} />
                </AnalyticsProvider>
              </PageProvider>
            </DreamErrorBoundary>
          </DreamClientThemeProvider>
        </DreamServerThemeProvider>
      </body>
    </html>
  );
}
